import { HFlow, Tag, Text } from 'bold-ui'
import { CustomMultiSelectFieldProps, SelectField } from 'components/form/final-form'
import { IvcfSubgrupoPerguntaEnum } from 'graphql/types.generated'
import { IVCF_GRUPOS, IVCF_SUBGRUPOS } from 'view/atendimentos/detail/soap/objetivo/ivcf/model-ivcf'

type IvcfSubgrupoSelectFieldProps = CustomMultiSelectFieldProps<IvcfSubgrupoPerguntaEnum>

export function IvcfSubgrupoSelectField(props: IvcfSubgrupoSelectFieldProps) {
  return (
    <SelectField<IvcfSubgrupoPerguntaEnum>
      items={items}
      itemToString={renderString}
      renderItem={renderItem}
      multiple
      placeholder='Selecione ou digite dimensões alteradas'
      {...props}
    />
  )
}

const renderString = (item: IvcfSubgrupoPerguntaEnum) => item && IVCF_SUBGRUPOS[item].label

const renderItem = (item: IvcfSubgrupoPerguntaEnum) => {
  const subgrupo = IVCF_SUBGRUPOS[item]
  return (
    <HFlow hSpacing={1} alignItems='center'>
      <Tag>{IVCF_GRUPOS[subgrupo.grupo].title}</Tag>
      <Text>{subgrupo.label}</Text>
    </HFlow>
  )
}

const items: IvcfSubgrupoPerguntaEnum[] = Object.values(IvcfSubgrupoPerguntaEnum)
